import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';
import { AggridsacicotComponent } from '../../advantage/aggridsacicot/aggridsacicot.component';

import { Venenccotizacion } from "../veninterfaces/venenccotizacion";
import { VenenccotizacionService } from "../venservicios/venenccotizacion.service";
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { CellEditorCotizacion } from "../../advantage/config/cell-edit-cotizacion";

import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { InvbusquedaService } from 'src/app/inv/invservicios/invbusqueda.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-venenccotizacion',
  templateUrl: './venenccotizacion.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class VenenccotizacionComponent implements OnInit, OnChanges {
  @ViewChild(AggridsacicotComponent) aggrid: AggridsacicotComponent;

  @Input() encabezado: Venenccotizacion
  @Input() decimalesCantidad
  @Input() decimalesCosto;
  @Input() decimalesTotal;
  @Input() decimalesPrecio;
  @Input() decimalesTOTALFAC;
  @Input() TIPDET;
  @Input() modo;

  cmbProceso: any[];
  selectProceso: any;
  grafico
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  defaultColDef;
  comboOpciones: any[];
  botonFactura: boolean;
  tipodetalle: string;
  bolNuevodet: boolean;
  largo: string;
  rowData = [];

  // busqueda
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  spin
  consulta: string;
  //dialogs
  displayDialogBusquedaFast: boolean;
  booleanall;

  columnDefsDetcotiza = []
  constructor(public venenccotizacionService: VenenccotizacionService,
    private busqService: InvbusquedaService, ) {
    this.agTable();
  }
  ngOnChanges(changes) {
    if (changes.decimalesTotal || changes.decimalesCosto || changes.decimalesCantidad) {
      this.crearColumnas()
      if (this.aggrid && this.aggrid.gridApi) {
        this.aggrid.gridApi.setColumnDefs(
          this.columnDefsDetcotiza
        )
      }
    }
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorCotizacion
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDef = {
      editable: true,
      width: 100,
      objeto: 'detcotiza',
      resizable: true
    };
    // this.rowStyle = (params) => {
    //   if (params.data.DETFAC_TIPODET === 'Y') {
    //     return { background: 'rgb(255, 204, 255)' };
    //   }
    // };
  }
  ngOnInit() {
    this.largo = '630';
    this.comboOpciones = [{ label: 'A', value: 'A' },
    { label: 'S', value: 'S' }, { label: 'I', value: 'I' }, { label: '*', value: '*' }];
    this.botonFactura = false;
    this.venenccotizacionService.registrarcotizacion(this.encabezado)

    //this.venenccotizacionService.obtenerDetalle(this.encabezado.ENCCOTIZA_NUMERO)
    this.venenccotizacionService.decimalesCantidad = this.decimalesCantidad
    this.venenccotizacionService.decimalesCosto = this.decimalesCosto
    this.venenccotizacionService.decimalesTotal = this.decimalesTotal
    this.venenccotizacionService.decimalesPrecio = this.decimalesPrecio
    this.venenccotizacionService.decimalesTOTALFAC = this.decimalesTOTALFAC
    this.crearColumnas();
    if (this.modo === 'pendiente') {
      this.booleanall=false
    }else if (this.modo === 'aprobado' || this.modo === 'bloqueo') {
      this.booleanall=true
    }
    //console.log('this.decimalesTotal', this.decimalesTotal)
  }
  guardarcot(numero){

  }
  anularcot(numero){
    
  }
  crearColumnas() {
    this.columnDefsDetcotiza = [
      { // 0
        headerName: 'Bodega', field: 'BOD_CODIGO', cellEditor: 'cellPrueba', width: 80,
        // editable: true,
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: true,
            saltoslinea: 0,
            newrow: false,
            numerodecimales: 0,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 10,
            opcionbuscar: true
          }
        }
      },
      { // 1
        headerName: 'Código', field: 'DETCOTIZA_CODIGO', cellEditor: 'cellPrueba',
        editable: (params) => {
          return true
        },
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: true,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: 0,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 25,
            opcionbuscar: true
          }
        }
      },
      { // 2
        headerName: 'Descripción', field: 'DETCOTIZA_DESCRIPCION', cellEditor: 'cellPrueba', width: 200,

        editable: true,
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: true,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: 0,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 200
          }
        }
      },
      { // 5
        headerName: 'Unidad', field: 'DETCOTIZA_UNIDAD', cellEditor: 'agSelectCellEditor', editable: true, width: 80,

        cellEditorParams:
        {
          values: []
        }
      },
      { // 6
        headerName: 'Cantidad', field: 'DETCOTIZA_CANTIDAD', cellEditor: 'cellPrueba', width: 90,
        editable: (params) => {

          return true;
        },
        // , editable: true,
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.decimalesCantidad,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        }
      },
      { // 7
        headerName: 'Costo', field: 'DETCOTIZA_COSTO', cellEditor: 'cellPrueba', width: 90,

        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.decimalesCosto,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32,
            tienecalculos: true,
            autorizacion: true
          }
        }
      },
      { // 9
        headerName: 'Total', field: 'DETCOTIZA_TOTAL', cellEditor: 'cellPrueba', width: 90,
        // , editable: true,
        editable: (params) => {
          return false
        },
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.decimalesTotal,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32
          }
        }
      },
      { // 1
        headerName: 'Cod.Prov', field: 'PRO_CODIGO', cellEditor: 'cellPrueba',
        editable: (params) => {
          return true
        },
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: true,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: 0,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 25,
            opcionbuscar: true
          }
        }
      },
      {
        headerName: 'Nombre Proveedor', field: 'PRO_NOMBRE', width: 200,
        editable: (params) => {
          return false
        },
      },
      {
        headerName: 'Tipo', field: 'DETCOTIZA_TIPODET', width: 200,
        editable: (params) => {
          return false
        },
      },
    ]
  }
  cambiarFoco(event) {
    let element: any;
    //console.log(event.target)
    switch (event.target.id) {
      case 'ART_CODIGO': {
        this.abrirarticulo(event.target.value);
        break;
      }
      case 'ENCCOTIZA_TIRO': {
        element = document.getElementById('ENCCOTIZA_RETIRO');
        break;
      }
      case 'ENCCOTIZA_RETIRO': {
        element = document.getElementById('ENCCOTIZA_ANCHO');
        break;
      }
      case 'ENCCOTIZA_ANCHO': {
        element = document.getElementById('ENCCOTIZA_LARGO');
        break;
      }
      case 'ENCCOTIZA_LARGO': {
        element = document.getElementById('ENCCOTIZA_CANTIDAD');
        break;
      }
      case 'ENCCOTIZA_CANTIDAD': {
        this.venenccotizacionService.calculartotal(this.encabezado.ENCCOTIZA_NUMERO)
        element = document.getElementById('ENCCOTIZA_NUMPLACAS');
        break;
      }
      case 'ENCCOTIZA_NUMPLACAS': {
        element = document.getElementById('formula');
        break;
      }
      case 'formula': {
        element = document.getElementById('ENCCOTIZA_MACULATURA');
        break;
      }
      case 'ENCCOTIZA_MACULATURA': {
        this.venenccotizacionService.calculartotal(this.encabezado.ENCCOTIZA_NUMERO)
        element = document.getElementById('ENCCOTIZA_BODPT');
        break;
      }
      case 'ENCCOTIZA_BODPT': {
        this.abrirbodega(event.target.value, 'pt');
        break;
      }
      case 'ENCCOTIZA_BODMP': {
        this.abrirbodega(event.target.value, 'mp');
        break;
      }
      case 'GRUP_CODIGO': {
        //this.abrirgrupo(event.target.value);
        break;
      }
      default: {
        break;
      }
    }
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }

  }
  cambio(evento) {

  }
  async abrirarticulo(parametro) {
    this.opcionbusqueda = 'articulo';
    this.types = [
      { label: 'Orden', value: 'ART_CODIGO' },
      { label: 'Nombre', value: 'ART_NOMBRE' },
      { label: 'Grupo', value: 'GRUP_CODIGO' },
      { label: 'NombreCorto', value: 'ART_NOMBREC' },
      { label: 'CodigoAlterno', value: 'ART_CODIGOALT1' },
      { label: 'Ubicación', value: 'ART_UBICACION' },
      { label: 'Laboratorio', value: 'ART_LABORATORIO' },
      { label: 'Alterno2', value: 'ART_CODIGOALT2' },
    ];
    this.busquedacampos = [parametro, '', '', '', '', '', '', ''];
    this.consulta = '*';
    this.tabla = 'INV_MAEARTICULO';
    this.where = 'COM_CODIGO = \'01\' AND ART_ACTIVO=\'S\'';

    if (parametro !== '' && parametro !== undefined && parametro !== null) {
      const eR = await this.venenccotizacionService.encontrararticulo(parametro);
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
          return;
        }
      }
    }

    this.busqService.busquedaInvMaeArticulo5(parametro).subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.displayDialogBusquedaFast = true;
    });
  }
  changeProceso() {

  }
  async abrirbodega(parametro, tipo) {
    if (tipo === 'mp') {
      this.opcionbusqueda = 'bodegamp';
    }
    if (tipo === 'pt') {
      this.opcionbusqueda = 'bodegapt';
    }
    this.types = [
      { label: 'Código', value: 'BOD_CODIGO' },
      { label: 'Nombre', value: 'BOD_NOMBRE' },
    ];
    this.busquedacampos = [parametro, '', '', '', '', '', '', '', '', ''];
    this.consulta = '*';
    this.tabla = 'INV_MAEBODEGA';
    this.where = '';
    if (parametro !== '' && parametro !== undefined && parametro !== null) {
      const eR = await this.venenccotizacionService.encontrarbodega(parametro);
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
          return;
        }
      }
    }

    this.busqService.busquedaInvMaeBodega1(parametro).subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.displayDialogBusquedaFast = true;
    });
  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'articulo') {
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ART_CODIGO = opcion.ART_CODIGO;
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ART_NOMBRE = opcion.ART_NOMBRE;
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ENCCOTIZA_LARGO = isNullOrUndefined(opcion.ART_ALTURA) ? '' : opcion.ART_ALTURA
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ENCCOTIZA_ANCHO = isNullOrUndefined(opcion.ART_ANCHO) ? '' : opcion.ART_ANCHO
      this.ingresaTiposProcesos();
      document.getElementById('ENCCOTIZA_TIRO').focus();
    }
    if (this.opcionbusqueda === 'bodegamp') {
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ENCCOTIZA_BODMP = opcion.BOD_CODIGO
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].BODMP_NOMBRE = opcion.BOD_NOMBRE
    }
    if (this.opcionbusqueda === 'bodegapt') {
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ENCCOTIZA_BODPT = opcion.BOD_CODIGO
      this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].BODPT_NOMBRE = opcion.BOD_NOMBRE
      document.getElementById('ENCCOTIZA_BODMP').focus();
    }
    this.displayDialogBusquedaFast = false;
  }
  async ingresaTiposProcesos() {
    const formulitas = [{ codigo: '', name: '' }];
    this.selectProceso = { codigo: '', name: '' };
    this.cmbProceso = []
    const data = await this.venenccotizacionService.getTipoProceso(this.venenccotizacionService.cotizacionesMap[this.encabezado.ENCCOTIZA_NUMERO].ART_CODIGO);
    if (data !== null) {
      if (data.length > 0) {
        for (const rs of data) {
          this.cmbProceso.push({ label: rs.FOR_CODIGO, value: rs.FOR_CODIGO });
        }
      }
    }
    console.log('cmbProceso', this.cmbProceso)
  }
  selecciondetfac(params) {
    if (this.modo === 'aprobado' || this.modo === 'bloqueo'){
      return;
    }
    if (params === 'nuevo') {
      //console.log(this.encabezado)
      this.nuevalinea()
    }

  }
  nuevalinea() {
    if (this.tipodetalle === undefined) {
      this.tipodetalle = this.TIPDET === null || this.TIPDET === undefined ? 'A' : this.TIPDET;

    }
    this.venenccotizacionService.agregarfila(this.encabezado.ENCCOTIZA_NUMERO, this.tipodetalle)


    // this.encabezado.detalle = [
    //   ...this.venenccotizacionService.obtenerDetalle(this.encabezado.ENCCOTIZA_NUMERO)
    // ]
    setTimeout(() => {
      this.aggrid.focusUltimaFila()
    });

  }
  rdbtipodet(params) {
    this.tipodetalle = params;
  }

}
